export enum RouteNames {
  PLAY_MENU = "play-menu",
  DOJO = "dojo",
  DOJO_TRAINING_CONFIG = "dojo-training-config",
  DOJO_TEAM_SELECT = "dojo-team-select",
  DOJO_BATTLE = "dojo-battle",
  DOJO_SANDBOX = "dojo-sandbox",
  POKEMON_INFO = "pokemon-info",
  SHOP = "shop",
  INVENTORY_POKE = "inventory-poke",
  LEADERBOARD = "leaderboard",
  ARENA_TEAM_SELECT = "arena-team-select",
  DUEL_QUEUE = "duel-queue",
  BATTLE_TEST = "battle-test",
  PLAYER_PROFILE = "player-profile",
  PROFILE_SETTINGS = "profile-settings",
  DEX = "dex",
  DEX_DETAILS = "dex-details",
  ITEM_DECK_LIST = "item-deck-list",
  ITEM_DECK_EDIT = "item-deck-edit",
  TRAINING_FACILITY = "training-facility",
  PACKS = "packs",
  SIEGE = "siege",
  // Challenge routes (content-challenges, P1)
  CHALLENGE = "challenge",
  AUCTION = "auction",
  // Social layer routes (social-layer, P2)
  FRIENDS = "friends",
}